/* Move a cart line into the browser-local saved-equipment shortlist.
   This is intentionally a full line removal after a successful local write. It
   prevents the cart from becoming a temporary wishlist while preserving the
   shopper's ability to reopen the exact product later. */
(function () {
  'use strict';
  var KEY = 'bagGuestShortlist.v1';
  var MAX_ITEMS = 20;

  function read() {
    try {
      var rows = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(rows) ? rows.filter(function (row) {
        return row && row.id && row.title && row.url;
      }).slice(0, MAX_ITEMS) : [];
    } catch (e) { return []; }
  }

  function write(rows) {
    try { localStorage.setItem(KEY, JSON.stringify(rows.slice(0, MAX_ITEMS))); return true; }
    catch (e) { return false; }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ctx-cart-save-remove]');
    if (!button) return;
    event.preventDefault();

    var product = {
      id: String(button.dataset.ctxSaveId || ''),
      title: String(button.dataset.ctxSaveTitle || ''),
      url: String(button.dataset.ctxSaveUrl || ''),
      image: String(button.dataset.ctxSaveImage || ''),
      price: String(button.dataset.ctxSavePrice || ''),
      condition: String(button.dataset.ctxSaveCondition || '').trim(),
      savedAt: Date.now()
    };
    var removeUrl = String(button.dataset.ctxCartSaveRemove || '');
    if (!product.id || !product.title || !product.url || !removeUrl) return;

    var rows = read();
    if (!rows.some(function (row) { return row.id === product.id; })) {
      rows.unshift(product);
      if (!write(rows)) return;
    }

    button.disabled = true;
    button.textContent = 'Saved';
    window.location.assign(removeUrl);
  });
}());
